import { Injectable, inject } from '@angular/core';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { RedirectRequest } from '@azure/msal-browser';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private readonly msal = inject(MsalService);
  private readonly msalBroadcast = inject(MsalBroadcastService);

  /** Inicia el flujo de login con redirect a Azure AD */
  login(): void {
    this.msal.loginRedirect({
      scopes: [environment.azureAd.apiScope],
    } as RedirectRequest);
  }

  /** Cierra sesión y redirige a postLogoutRedirectUri */
  logout(): void {
    this.msal.logoutRedirect();
  }

  /** Indica si hay al menos una cuenta en sesión */
  get isLoggedIn(): boolean {
    return this.msal.instance.getAllAccounts().length > 0;
  }

  /** Observable que emite true cuando no hay interacción en curso y hay cuenta (útil tras redirects) */
  get isLoggedIn$(): Observable<boolean> {
    return this.msalBroadcast.inProgress$.pipe(
      filter((status) => status === InteractionStatus.None),
      map(() => this.msal.instance.getAllAccounts().length > 0)
    );
  }

  /** Cuenta activa (primera cuenta) o null */
  get activeAccount() {
    return this.msal.instance.getActiveAccount() ?? this.msal.instance.getAllAccounts()[0] ?? null;
  }

  /** Nombre para mostrar del usuario */
  get displayName(): string | null {
    const account = this.activeAccount;
    return account?.name ?? account?.username ?? null;
  }
}
